import { useDispatch, useSelector } from "react-redux";
import { mainActions } from "../../../store";
import classes from "./EarTrainerSetup.module.css";

const EarTrainerShowNotesSelect = () => {
  const dispatch = useDispatch();

  const earTrainerShowNotes = useSelector((state) => state.earTrainerShowNotes);

  const showNotesChangeHandler = (event) => {
    dispatch(mainActions.setEarTrainerShowNotes(+event.target.value));
  };

  return (
    <tr>
      <td className={classes.td}>
        <select
          aria-label="Diagram markers"
          value={earTrainerShowNotes}
          onChange={showNotesChangeHandler}
          className={classes.select}
        >
          <option value="0">All scale notes</option>
          <option value="1">Roots only</option>
          <option value="2">Lowest root only</option>
          <option value="3">Highest root only</option>
        </select>
      </td>
      <td>Markers shown on the diagram</td>
    </tr>
  );
};

export default EarTrainerShowNotesSelect;
